import { sideOrder } from "./constants";

/**
 * The most shares an order may ask for: what the client holds, when selling.
 *
 * The cap is the position's quantity, which is a limit on a sale and nothing
 * else. It was applied to buying too, so a client holding 9 ARKG could not
 * buy 10: the field turned any larger number back into 9. A buy is bounded
 * by the cash, which the form checks on its own.
 */
export const quantityCap = (side: string, held?: number): number | undefined =>
  side === sideOrder.SELL && typeof held === "number" && held > 0
    ? held
    : undefined;
